<template>
  <div
    v-if="isLoading2 == true"
    style="
      font-weight: 800;
      border-radius: 10px;
      padding: 50px;
      font-size: large;
      text-align: center;
      background: #73737326;
    "
    class="loader text-success"
  >
    جاري التحميل
    <div class="spinner-border text-success" role="status">
      <span class="sr-only"></span>
    </div>
  </div>
  <div class="d-flex flex-column flex-root" id="kt_app_root">
    <!--begin::Authentication - Sign-in -->
    <div class="d-flex flex-column flex-lg-row flex-column-fluid">
      <!--begin::Body-->
      <div
        class="d-flex flex-column flex-lg-row-fluid w-lg-50 order-2 order-lg-1"
        style="background: #fafafa"
      >
        <!--begin::Form-->
        <div class="d-flex flex-center flex-column flex-lg-row-fluid">
          <!--begin::Wrapper-->
          <div class="p-2 w-lg-500px" style="width: 90%">
            <!--begin::Form-->
            <div class="p-2">
              <h1 class="mb-5 text-center">تسجيل الدخول</h1>
              <hr />
              <h1
                class="mb-5 text-center text-light"
                style="font-weight: 700; font-size: larger; color: #29ca50 !important"
              >
                Academia | أكاديميا
              </h1>
              <div class="loader-login-box text-center">
                <h6 style="color: #10ce36">.. الرجاء الإنتظار</h6>
                <div
                  class="spinner-border spinner-border-lg text-light"
                  role="status"
                  style="color: #6dff89 !important; height: 120px; width: 120px"
                >
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
              <form
                class="form-horizontal loginWithoutOtp"
                action="home.html"
                style="display: none"
              >
                <div style="min-height: 10px">
                  <span
                    id="error-message"
                    style="color: red; display: none; text-align: right"
                  >
                    يرجى تحديد رقم الهاتف يرجى تحديد رقم الهاتف يرجى تحديد رقم الهاتف يرجى
                    تحديد رقم الهاتف</span
                  >
                  <div id="cert-btn" style="text-align: center; display: none"></div>
                </div>
                <div class="row" dir="rtl">
                  <div class="col-md-12">
                    <div
                      class="form-group form-group-custom mb-4"
                      id="phone-login-box"
                      dir="rtl"
                    >
                      <label class="text-right" for="phone">رقم الهاتف</label>
                      <div class="input-group">
                        <input
                          type="tel"
                          class="form-control ml-1"
                          style="width: 100%"
                          id="phone"
                          maxlength="10"
                          max="9999999999"
                        />
                      </div>
                      <span id="phone-error" style="color: red; display: none"
                        >يرجى تحديد رقم الهاتف</span
                      >
                    </div>

                    <div class="form-group form-group-custom mb-4" dir="rtl">
                      <label for="password">كلمة المرور</label>
                      <input
                        type="password"
                        class="form-control"
                        id="password"
                        placeholder="..........."
                      />
                      <span id="password-error" style="color: red; display: none">
                        يرجى تحديد الرمز السري</span
                      >
                    </div>

                    <div class="row">
                      <div class="col-md-6">
                        <div class="text-md-right mt-3 mt-md-0">
                          <a
                            href=""
                            class="text-muted"
                            data-bs-toggle="modal"
                            data-bs-target="#forgetpassword-modal"
                            ><i class="mdi mdi-lock"></i> نسيت كلمة المرور</a
                          >
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div
                          class="text-md-right mt-3 mt-md-0 float-end"
                          style="margin-left: 12px"
                        >
                          <a
                            href=""
                            class="text-muted"
                            data-bs-toggle="modal"
                            data-bs-target="#retrieve-device-modal"
                            ><i class="mdi mdi-lock"></i> أضعت جهازي الرئيسي
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class="d-grid gap-2">
                      <div class="mt-4 login">
                        <button
                          class="p-3 btn btn-success btn-block waves-effect waves-light"
                          style="height: 55px; font-size: 19px; width: 100%"
                          type="button"
                          @click="login()"
                        >
                          تسجيل دخول <i class="mdi mdi-application-export"></i>
                        </button>
                      </div>
                    </div>

                    <hr />
                    <div class="row" dir="rtl">
                      <div class="col-md-6 col-6">
                        <div class="mt-2 text-right">
                          <a
                            href=""
                            data-bs-toggle="modal"
                            data-bs-target="#qr-code-modal"
                            class="text-muted"
                            ><i class="mdi mdi-qrcode"></i> رمز QR</a
                          >
                        </div>
                      </div>
                      <div class="col-md-6 col-6">
                        <div class="mt-2 text-left float-end" style="margin-left: 12px">
                          <a href="register" class="text-muted"
                            ><i class="mdi mdi-account"></i> إنشاء حساب جديد</a
                          >
                        </div>
                      </div>
                      <br />
                      <br />

                      <div class="col-md-6 col-6">
                        <div class="mt-2 text-right" style="margin-left: 12px">
                          <a href="privacy-policy" target="_blank" class="text-muted"
                            ><i class="mdi mdi-account"></i> سياسة الخصوصية
                          </a>
                          |
                          <a href="terms-of-service" target="_blank" class="text-muted"
                            ><i class="mdi mdi-account"></i> سياسة الإستخدام
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <!--end::Wrapper-->
        </div>
        <!--end::Form-->
        <!--begin::Footer-->
        <div class="w-lg-500px d-flex flex-stack px-10 mx-auto">
          <!--begin::Languages-->
          <div class="me-10"></div>
          <!--end::Languages-->
        </div>
        <!--end::Footer-->
      </div>
      <!--end::Body-->
      <!--begin::Aside-->
      <div
        class="d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center order-1 order-lg-2"
        style="background: #fff"
      >
        <!--begin::Content-->
        <div class="d-flex flex-column flex-center py-7 py-lg-15 px-5 px-md-15 w-100">
          <!--begin::Logo-->
          <a href="#" class="mb-0 mb-lg-12">
            <img alt="Logo" src="assets/img/logo-dark.png" class="h-60px h-lg-75px" />
          </a>
          <!--end::Logo-->
          <!--begin::Image-->
          <img
            class="d-none d-lg-block mx-auto w-275px w-md-50 w-xl-500px mb-10 mb-lg-20"
            src="assets/img/learningv2.gif"
            alt=""
          />
          <!--end::Image-->
          <!--begin::Title-->
          <h1 class="d-none d-lg-block text-success fs-2qx fw-bolder text-center mb-7">
            أكاديميا - تعلم بلا حدود
          </h1>
          <!--end::Title-->
          <!--begin::Text-->

          <div class="d-none d-lg-block text-success fs-base text-center">
            تطبيق أكاديميا يوفر تعليم عالي الجودة لطلاب المدارس الإعدادية والثانوية
            والجامعة. بفضل ميزاته المميزة ونهجه التكنولوجي، يمكن للطلاب الوصول إلى محتوى
            تدريب متميز في أي وقت ومن أي مكان.
          </div>
          <!--end::Text-->
        </div>
        <!--end::Content-->
      </div>
      <!--end::Aside-->
    </div>
    <!--end::Authentication - Sign-in-->

    <div
      dir="rtl"
      class="modal fade qr-code-modal"
      id="qr-code-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">الدخول عن طريق QR Code</h5>
          </div>
          <div class="modal-body">
            <h4 class="mb-2 text-center">قم بمسح رمز الـ Qr لإتمام عملية الدخول</h4>
            <div
              class="qr-code-box"
              id="qrcode"
              style="width: 150px; height: 150px; margin-top: 15px; margin: 0 auto"
            ></div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              تراجع
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ForgotPassword />
  <LostMyDevice />
  <VerifyAccount />

  <!---------------Forgot Password Modal----------------------------------------->
</template>
<script>
import { hashV2 } from "@/utils/api";
import QRCode from "qrcodejs2";
import ForgotPassword from "./auth/ForgotPassword.vue";
import LostMyDevice from "./auth/LostMyDevice.vue";
import VerifyAccount from "./auth/VerifyAccount.vue";
import { backupToookie } from "@/utils/cookieBackup";

import { apiUrl, deviceId, baseUrl, getBrowserName } from "@/utils/api"; // Adjust the import path according to your project structure
// Adjust the import path according to your project structure
var iti;

export default {
  name: "Login",
  components: {
    ForgotPassword,
    LostMyDevice,
    VerifyAccount,
  },
  data() {
    return {
      phoneOtpError: false,
      phoneError: false,
      errorMessage: "",
      isLoading2: true,
    };
  },
  mounted() {
    localStorage.removeItem("access_token_vr");

    this.getBalance();
    $(document).ready(function () {
      var qrcode = new QRCode(document.getElementById("qrcode"), {
        width: 150,
        height: 150,
      });

      qrcode.makeCode(deviceId + "//" + getBrowserName());
      $(".loginWithoutOtp").hide();
      $(".loginWithOtp").hide();
      $.ajax({
        //url: "http://ec2-157-175-164-163.me-south-1.compute.amazonaws.com/api/home?secret=a463c0cd-78ed-4bda-a5f6-f70c3e597dfb",
        url: apiUrl + "/home/web",
        method: "GET",
        dataType: "json",
        success: function (response) {
          //console.log(response);
          $(".loader-login-box").hide();

          var otpStatus = 0;
          var phone;
          if (otpStatus == 0) {
            $(".loginWithoutOtp").show();
            $(".loginWithOtp").hide();
            phone = document.querySelector("#phone");
          }
          if (otpStatus == 1) {
            $(".loginWithoutOtp").hide();
            $(".loginWithOtp").show();
            phone = document.querySelector("#phoneOtp");
          }
          iti = intlTelInput(phone, {
            utilsScript: "assets/js/utils.js",
            initialCountry: "ly", // Set Libya as the default country
            separateDialCode: true,
            excludeCountries: ["il"],
          });
        },
        error: function (error) {},
      });
    });

    if (localStorage.getItem("access_token")) {
      //console.log(localStorage.getItem('access_token'));
      //alert(localStorage.getItem("access_token"));
      //window.location.href = "/home";
    }
    //console.log(localStorage.getItem('respo'));

    document.querySelector("#phone").addEventListener("keyup", (event) => {
      if (event.keyCode === 13) {
        this.login();
      }
    });

    document.querySelector("#password").addEventListener("keyup", (event) => {
      if (event.keyCode === 13) {
        this.login();
      }
    });

    document.querySelector("#phone").addEventListener("input", function (ev) {
      var maxlength = this.getAttribute("max").length;
      var value = this.value;
      if (value && value.length >= maxlength) {
        this.value = value.substr(0, maxlength);
      }
    });
  },
  methods: {
    login() {
      const $loginBtn = $(".login button");
      const $phoneErrorElem = $("#phone-error");
      const $passwordErrorElem = $("#password-error");
      const $errorMessageElem = $("#error-message");

      $phoneErrorElem.hide();
      $passwordErrorElem.hide();
      $errorMessageElem.hide();

      const mobile = $("#phone").val();
      const password = $("#password").val();
      const platform = "web";
      const version = "11.0.0";

      if (!mobile) {
        $phoneErrorElem.show();
        return;
      }
      if (!password) {
        $passwordErrorElem.show();
        return;
      }

      // Show the loading spinner
      $loginBtn.html(
        '<div class="spinner-border spinner-border-lg text-light" role="status"><span class="sr-only">Loading...</span></div>'
      );

      const payload = {
        mobile: iti.getNumber(),
        country_code: "+" + iti.getSelectedCountryData().dialCode,
        password,
        platform,
        version,
      };

      $.ajax({
        url: apiUrl + "/login/web",
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Accept: "application/json",
          Authorization: "Bearer oeKNF8MEnoTtcaCOAcr0XT7dYQgnLXUsiyTNyGvY",
        },
        data: payload,
      })
        .done((response) => {
          if (response.message) {
            $errorMessageElem.text(response.message).show();
          } else if (response.access_token) {
            // Store access token
            localStorage.setItem("access_token_vr", response.access_token);
            backupToookie("access_token_vr", response.access_token);

            // بعد ما نخزن الـ token نعمل له call جديد على /home/web
            $.ajax({
              url: apiUrl + "/home/web",
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: "Bearer " + localStorage.getItem("access_token_vr"),
              },
            }).done((homeResponse) => {
              localStorage.setItem("access_token", response.access_token);
              backupToookie("access_token", response.access_token);
              // alert(localStorage.getItem("access_token"));
              // هنا يعتمد على قيمة is_verified
              if (homeResponse.is_verfied === false) {
                // عرض المودال
                const modal = new bootstrap.Modal(
                  document.getElementById("user-verification-modal")
                );
                modal.show();
                return;
                /*localStorage.setItem("access_token", response.access_token);
                localStorage.setItem("expires_in", response.expires_in);

                window.location.href = "/home";*/
                localStorage.setItem("access_token", response.access_token);
                backupToookie("access_token", response.access_token);
                localStorage.setItem("expires_in", response.expires_in);
                backupToookie("expires_in", response.expires_in);

                window.location.href = "/home";
              } else {
                // توجيه في حالة verified
                localStorage.setItem("access_token", response.access_token);
                backupToookie("access_token", response.access_token);
                localStorage.setItem("expires_in", response.expires_in);
                backupToookie("expires_in", response.expires_in);

                window.location.href = "/home";
              }
            });
          }
        })

        .fail((response) => {
          const res = response.responseJSON;
          if (res.message) {
            $errorMessageElem.text(res.message).show();
            if (response.status == 406) {
              $("#cert-btn")
                .html(
                  "<a href=" +
                    baseUrl +
                    'login-verify-users" target="_blank" class="btn btn-sm btn-success text-center cert- mt-2"><i class="fa fa-arrow-right"></i>  توثيق الأن  </a>'
                )
                .show();
            }
          }
        })
        .always(() => {
          // Restore the original button text after the request is done
          $loginBtn.html('تسجيل دخول <i class="mdi mdi-application-export"></i>');
        });
    },
    // End Update By Alfaqieh 27/7/2023

    async getBalance() {
      // إخفاء الـ body
      console.log("Hiding body...");
      $("#kt_app_root").addClass("hidden-login");
      try {
        const response = await fetch(
          `${apiUrl}/wallets/get-balance?secret=a463c0cd-78ed-4bda-a5f6-f70c3e597dfb`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${this.token}`,
              "Content-Type": "application/json",
            },
          }
        );
        this.isLoading2 = false;
        if (response.redirected) {
          $("#kt_app_root").removeClass("hidden-login");
        } else {
          window.location.href = "/home";
        }
      } catch (error) {
        console.error("Error fetching balance:", error);
      } finally {
      }
    },
  },
};
</script>
<style scoped>
.form-control {
  height: 55px;
  font-size: 19px;
  width: 100%;
}
</style>
